export const onlyNumbers = (value: any = "") => {
  return value.replace(/\D/g, "")
}
